export const getProposalName = state => state.proposalName;
